export default __webpack_public_path__ + "static/media/my-vets.ed48eb50.svg";